import React from 'react';
import { FormControl } from 'react-bootstrap';
import AudienceMappingManager from './models/AudienceMappingManager';
import {
  hasUnsafeFilenameChars,
  UNSAFE_CHARS_ERROR_MESSAGE,
} from '../../utils';

type AudienceTitleProps = {
  audienceMappingManager: AudienceMappingManager;
  handleOnChangeAudienceName: (newAudienceName: string) => void;
  onValidationChange?: (isValid: boolean) => void;
};

type AudienceTitleState = {
  isAudienceNameCorrectFormat: boolean;
};

export default class AudienceTitle extends React.Component<
  AudienceTitleProps,
  AudienceTitleState
> {
  constructor(props: AudienceTitleProps) {
    super(props);
    this.state = {
      isAudienceNameCorrectFormat: true,
    };
    this.handleAudienceName = this.handleAudienceName.bind(this);
  }

  handleAudienceName(e: any) {
    const { value } = e.target;
    const isCorrectFormat = !hasUnsafeFilenameChars(value);

    this.props.handleOnChangeAudienceName(value);
    this.setState({
      isAudienceNameCorrectFormat: isCorrectFormat,
    });

    // Notify parent of validation state
    if (this.props.onValidationChange) {
      this.props.onValidationChange(isCorrectFormat);
    }
  }

  render() {
    const { isAudienceNameCorrectFormat } = this.state;
    const { audienceMappingManager } = this.props;

    if (audienceMappingManager.isNewAudience)
      return (
        <div className="form-row d-flex align-items-center">
          <p className="mb-0 col-3">New Audience Name:</p>
          <div className="col-4">
            <FormControl
              type="text"
              id="audienceName"
              className="form-control"
              onChange={this.handleAudienceName}
              value={audienceMappingManager.name}
              placeholder="Type your new audience’s name..."
            />
          </div>
          {!isAudienceNameCorrectFormat && (
            <div className="col text-danger font-italic">
              {UNSAFE_CHARS_ERROR_MESSAGE}
            </div>
          )}
        </div>
      );
    return (
      <div className="form-row align-items-center">
        <p className="mb-0 col-3">{audienceMappingManager.name}</p>
      </div>
    );
  }
}
